export const NAV = {
  logo: 'nav-logo',
  home: 'nav-home',
  about: 'nav-about',
  services: 'nav-services',
  industries: 'nav-industries',
  why: 'nav-why-choose-us',
  blog: 'nav-blog',
  contact: 'nav-contact',
  ctaButton: 'nav-cta-button',
  mobileToggle: 'nav-mobile-toggle',
};

export const HOME = {
  heroCta: 'hero-cta-button',
  heroSecondary: 'hero-secondary-button',
  serviceCard: 'service-card',
  industryCard: 'industry-card',
  valueCard: 'value-card',
};

export const CONTACT = {
  form: 'contact-form',
  name: 'contact-name-input',
  email: 'contact-email-input',
  phone: 'contact-phone-input',
  company: 'contact-company-input',
  service: 'contact-service-select',
  message: 'contact-message-input',
  submit: 'contact-submit-button',
  success: 'contact-success-message',
};

export const NEWSLETTER = {
  email: 'newsletter-email-input',
  submit: 'newsletter-submit-button',
};

export const BLOG = {
  list: 'blog-list',
  card: 'blog-card',
  readMore: 'blog-read-more',
};
